/**
 * Node types as the flat shape reports them. Note `nodeType` on an adapted node
 * is a different, legacy thing: it names a node by its parent's field.
 */
export const CURRICULUM_ENTITY_TYPES = {
  FOLDER: "FOLDER",
  COLLECTION: "COLLECTION",
  SET: "SET",
  ACTIVITY: "ACTIVITY",
};
